import React from 'react';
import classNames from 'classnames';

import './EmptyScreen.styles.scss';

type EmptyScreenProps = {
  className?: string;
  title?: string;
  content?: string;
  children?: React.ReactNode;
};

const EmptyScreen: React.FC<EmptyScreenProps> = (props) => {
  const { children, className, title, content } = props;

  const classes = classNames('empty-screen', className);

  return (
    <div className={classes}>
      <p className="empty-screen__title">{title}</p>
      <p className="empty-screen__content">{content}</p>
      {children}
    </div>
  );
};

export default EmptyScreen;
